<template>
    <div class="content-schedule-multi-product-wrapper">
        <div :class="multiOrSingleGridLayoutStyle" v-for="(group, groupkey) in groups" :key="'group-'+ groupkey">
            <div v-if="isMultiProductDisplayMode" class="product-group-thumbnail-area" :style="thumbnailForProduct(group)"></div>
            <a v-if="isMultiProductDisplayMode" class="product-title-area" :href="detailsForProductURL(group)">{{ group[0].entity_name }}</a>
            <div class="scheduled-content-area">
                <scheduled-content-item :is-header-title="true"></scheduled-content-item>
                <scheduled-content-item
                    v-for="item in group"
                    :key="item.id"
                    :item-details="item"
                    :available-versions="availableVersions"
                    @hide-load-indicator="showGeneralLoadIndicator=false"
                    @show-load-indicator="showGeneralLoadIndicator=true"
                    @item-deleted="handleItemDeletion">
                </scheduled-content-item>
            </div>
        </div>
        <div class="schedule-content-warning-message" v-if="allScheduledContent.length === 0 && showGeneralLoadIndicator === false">
            No Scheduled Content Changes.
        </div>
        <div class="load-indicator" v-show="showGeneralLoadIndicator">
            <span class="fa fa-cog fa-spin fa-1x"></span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ScheduledContentItem from './scheduled-content-item.vue';

let base_url = window.location.protocol + "//" + window.location.host;

/*
Note:

This component displays schedule content in two different mode. The default mode shows all pending schedule changes for *all*
products. The second mode is used when a product id is passed into this component - which only lists pending changes for the given
product.

*/

export default {
    name: 'scheduled-content-changes',
    components: {
        ScheduledContentItem
    },
    props: {
        productId: {
            type: String,
            default: "-1"
        }
    },
    data() {
        return {
            showGeneralLoadIndicator: true,
            allScheduledContent: [],
            availableVersions: [
                {
                id: 0,
                name: "Master",
                slug: ""
                }
            ],
        }
    },
    computed: {
        groups() {
            //this method groups schedule changed by their product id. Only supports product type entities at the moment
            let grp = {};
            this.allScheduledContent.forEach(el => {
                if (el.entity_type === 'product') {
                    if (grp.hasOwnProperty('product' + el.entity_id) === false) {
                        grp['product' + el.entity_id] = [];
                    }
                    grp['product' + el.entity_id].push(el);
                }
            })
            return grp;
        },
        isSingleProductDisplayMode() {
            return this.productId !== "-1";
        },
        isMultiProductDisplayMode() {
            return !this.isSingleProductDisplayMode;
        },
        multiOrSingleGridLayoutStyle() {
            return {
                'content-schedule-single-product-container': this.isSingleProductDisplayMode,
                'content-schedule-multi-product-container': this.isMultiProductDisplayMode
            }
        }
    },
    mounted() {
        this.fetchScheduledContent();
        this.fetchVersions();
    },
    methods: {
        detailsForProductURL(groupDetails) {
            return base_url + "/products/" + groupDetails[0].entity_id+ "/edit/v2";
        },
        thumbnailForProduct(groupDetails) {
            return "background-image: url(" + groupDetails[0].entity_thumbnail + ");";
        },
        handleItemDeletion() {
            this.fetchScheduledContent();
        },
        fetchScheduledContent() {
            let uri = base_url + '/pimapi/scheduled-content';
            if (this.isSingleProductDisplayMode) {
                uri = uri + '?productId=' + this.productId
            }
            axios.get(uri)
            .then((response) => {
                this.showGeneralLoadIndicator = false;
                this.allScheduledContent = response.data.payload;
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
        },
        fetchVersions() {
            axios.get(base_url + '/pimapi/languages', {})
            .then((response) => {
                response.data.payload.forEach((element, idx) => {
                    this.$set(this.availableVersions, idx+1, element);
                });
            })
            .catch((error) => {
                console.log('version load ERROR!');
            });
        }
    }
}
</script>

<style>
    section.main-content {
        height: 100%;
    }
    .load-indicator {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        font-size: 1.5em;
    }
    .content-schedule-single-product-container {
        display: grid;
        grid-template-columns: 0px 0px 1fr;
        grid-template-rows: 0px 1fr;
    }
    .content-schedule-multi-product-container {
        display: grid;
        grid-template-columns: 64px 18px 1fr;
        grid-template-rows: 33px 1fr;
    }
    .product-title-area {
        grid-column-start: 3;
        grid-column-end: 4;
        grid-row-start: 1;
        grid-row-end: 2;
        margin-top: 5px;
        font-weight: bold;
    }
    .scheduled-content-area {
        grid-column-start: 3;
        grid-column-end: 4;
        grid-row-start: 2;
        grid-row-end: 3;
        margin-bottom: 25px;
    }
    .product-group-thumbnail-area {
        grid-column-start: 1;
        grid-column-end: 2;
        grid-row-start: 1;
        grid-row-end: 3;
        width: 64px;
        height: 64px;
        background-position: center;
        background-size: cover;
        overflow: hidden;
        border-radius: 32px;
        border: 1px solid #DEE0E1;
    }
    .schedule-content-warning-message {
        grid-column-start: 1;
        grid-column-end: 5;
        grid-row-start: 1;
        grid-row-end: 2;
    }

</style>